import { Chip } from "@nextui-org/react";

export default function V2ComponentChip() {
	return (
		<Chip color="warning" variant="dot" size="sm" className="ml-1">
			v2
		</Chip>
	);
}
